import React, { useState, useCallback, useLayoutEffect, useEffect, useReducer, useRef, useMemo, memo } from "react"
import { Main, MainToggle, SWAP_DURATION } from "./styles"
import { useMediaLoader, setPicture, setSource } from "./../hooks"
import { useWatchVariations, mvSubscribe } from "./../context"
import { useRoller } from "./../context.roller"
import { logmine, rafDelay } from "./../utils"
import Image from "components/media/ImageCLD"
import { useEnv } from "contexts/Env"
import { UPDATE_ROUTE, RESET_ROUTE } from "./../constants"

function useItems(entry, swapping, rfmain, is_reference) {
  //  logmine("CustomHook", "WatchRoller", "useItems")
  const env = useEnv()
  const preload = [
    {
      uid: "shadow",
      picture: {
        public_id: `catalogue/${env.catalogYear}/upright-c-shadow/${entry.get()}`,
        version: 1,
        width: 800,
        height: 1380,
        policy: "t_v7-main-configurator-shadow",
      },
    },
    {
      uid: entry.get(),
      picture: {
        public_id: `catalogue/${env.catalogYear}/upright-c/${entry.get()}`,
        version: 1,
        width: 800,
        height: 1180,
        policy: "t_v7-main-configurator",
      },
      selected: true,
    },
  ]
  const [items, setItems] = useState(preload)
  const rfshadow = useRef(null)

  function display(state) {
    rfmain.current?.classList[state ? "add" : "remove"]("wv_straight")
  }

  function update(v) {
    if (is_reference) return
    display(!!v)
    if (!v) return
    //    logmine("Callback", "WatchRoller", "useItems update", v)
    let [_stepindex, _start, ..._items] = v.split(",")

    const shadow_item = rfshadow.current || {
      uid: "shadow",
      picture: {
        public_id: `catalogue/${env.catalogYear}/upright-c-shadow/${_items[0]}`,
        version: 1,
        width: 800,
        height: 1380,
        policy: "t_v7-main-configurator-shadow",
      },
    }
    rfshadow.current = shadow_item

    _items = _items.map((v, i) => ({
      uid: v,
      picture: {
        public_id: `catalogue/${env.catalogYear}/upright-c/${v}`,
        version: 1,
        width: 800,
        height: 1180,
        policy: "t_v7-main-configurator",
      },
      //      selected: i == +_start,
    }))

    setItems([shadow_item].concat(_items))
  }

  useEffect(() => mvSubscribe("WatchRoller useItems swapping", swapping, update, false), [])

  return items
}

const Item = memo(({ picture, selected }) => {
  return (
    <figure className={selected ? "wv_reveal" : ""}>
      <Image sources={[picture]} loading='eager' sizes='(min-width: 48rem) 33vw, 100vw' />
    </figure>
  )
})

function buildZIndexes(arr) {
  let k = 1
  return arr.reduce((a, item) => {
    a[item] = k++
    return a
  }, Object.create(null))
}

function firstPos(arr, item) {
  const index = arr.indexOf(item)
  if (index < 0) return
  arr.splice(index, 1)
  arr.unshift(item)
}

function animate(list, selected, zIndexes) {
  list.forEach((el, i) => {
    //    console.log(">>>> animate", el, i, i === selected)
    el.classList[i === selected ? "add" : "remove"]("wv_reveal")
    rafDelay(() => (el.style.zIndex = zIndexes[i]))
    //    cssApply(el, fade(+(i === selected), zIndexes[i], straight))
  })
}

function useHighlight(items, ref, focus, swapping, incard) {
  //  console.log(">>> highlight")
  //  console.log(">>>>> useHighlight", items)
  const list = useRef(null)
  const col = useRef(null)
  const tm = useRef(null)

  const update = focus => {
    //    console.log(">>>> highlight update focus", focus)
    clearTimeout(tm.current)
    /*
        if (!swapping.current) ref.current?.classList.remove("wv_straight")
    console.log(">>>> highlight update focus", focus)*/
    if (!list.current) return
    firstPos(list.current, focus)
    const zIndexes = buildZIndexes(list.current.slice().reverse())
    //    console.log(">>> highlight before animate")
    animate(col.current, focus, zIndexes)
    //    console.log(">>> highlight animate")
    //    swapping.current = false
    //    if (incard >= 0) return
    tm.current = setTimeout(() => swapping.set(null), SWAP_DURATION)
  }

  useLayoutEffect(() => {
    //    console.log(">>> highlight useLayoutEffect items", items)
    /*
    swapping.current = true
    ref.current?.classList.add("wv_straight")*/
    if (!items) return
    list.current = items.map((v, i) => i)
    col.current = [...ref.current.querySelectorAll("figure")].slice(1)
    update(focus.get())
  }, [items])

  function onFocus(v) {
    if (!!swapping.get()) return
    update(v)
  }

  useEffect(() => mvSubscribe("WatchRoller useHighlight focus", focus, onFocus), [])
}

export const WatchRoller = ({ ctx, rctx }) => {
  //  logmine("Main", "WatchRoller")
  const { hashing, swapping, config, entry, newstepindex, stepindex, active, route, coverReady, loadQ, initQ, highlight, wrready, gready, incard } =
    useWatchVariations(ctx)
  const { focus } = useRoller(rctx)
  const rfmain = useRef()
  const rfwrapper = useRef()
  const items = useItems(entry, swapping, rfmain)
  const ready = useMediaLoader("WVWR", rfmain, items)

  function onReady(v) {
    wrready.set(v)
  }

  function onRoute(v) {
    let trans = !!v && v !== RESET_ROUTE && v !== UPDATE_ROUTE
    //console.log("onRouteonRoute", trans, v)
    rfwrapper.current?.classList[trans ? "add" : "remove"]("wv_trans")
  }

  function onGready(v) {
    if (v && newstepindex.get() !== 1) rfmain.current?.classList.add("wv_reveal")
  }

  function onNewstepindex(v) {
    if (v < 2) rfmain.current?.classList.remove("wv_reveal")
    else onReady(false)
  }

  useHighlight(items, rfmain, focus, swapping, incard)

  useEffect(() => mvSubscribe("WatchRoller ready", ready, onReady), [])
  useEffect(() => mvSubscribe("WatchRoller route", route, onRoute), [])
  useEffect(() => mvSubscribe("WatchRoller gready", gready, onGready), [])
  useEffect(() => mvSubscribe("WatchRoller newstepindex", newstepindex, onNewstepindex, false), [])

  return (
    <Main ref={rfmain}>
      <div ref={rfwrapper}>
        {items?.map(item => (
          <Item key={item.uid} {...item} />
        ))}
      </div>
    </Main>
  )
}

export const WatchRollerRef = ({ ctx }) => {
  //  logmine("Main", "WatchRoller")
  const { swapping, kill, entry, newstepindex } =
    useWatchVariations(ctx)
  //  const { focus } = useRoller(rctx)
  const rfmain = useRef()
  const rfwrapper = useRef()
  const items = useItems(entry, swapping, rfmain, true)
  const ready = useMediaLoader("WVWRF", rfmain, items)

  function onReady(v) {
    if (!v) return
    rfmain.current?.classList.add("wv_reveal")
  }

  function onRoute(v) {
    rfwrapper.current?.classList[!!v ? "add" : "remove"]("wv_trans")
  }

  function onGready(v) {
    if (v && newstepindex.get() !== 1) rfmain.current?.classList.add("wv_reveal")
  }

  function onNewstepindex(v) {
    if (v < 2) rfmain.current?.classList.remove("wv_reveal")
    else onReady(false)
  }

  //  useHighlight(items, rfmain, focus, swapping)

  useEffect(() => mvSubscribe("WatchRoller ready", ready, onReady), [])
  //  useEffect(() => mvSubscribe("WatchRoller route", route, onRoute), [])
  //  useEffect(() => mvSubscribe("WatchRoller gready", gready, onGready), [])
  //  useEffect(() => mvSubscribe("WatchRoller newstepindex", newstepindex, onNewstepindex, false), [])

  return (
    <Main ref={rfmain}>
      <div ref={rfwrapper} onClick={kill}>
        {items?.map(item => (
          <Item {...item} />
        ))}
      </div>
    </Main>
  )
}

export const ToggleRoller = ({ ctx, rctx }) => {
  //  logmine("Main", "WatchRoller")
  const { swapping, entry, incard } =
    useWatchVariations(ctx)
  const { focus } = useRoller(rctx)
  const rfmain = useRef()
  const items = useItems(entry, swapping, rfmain)

  useHighlight(items, rfmain, focus, swapping, incard)

  return (
    <MainToggle ref={rfmain}>
      {items?.map(item => (
        <Item key={item.uid} {...item} />
      ))}
    </MainToggle>
  )
}
